var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7731 5.12506H4.82673L7.30827 2.64352C7.59457 2.35735 7.75547 1.96917 7.75556 1.56437C7.75566 1.15957 7.59494 0.771317 7.30877 0.485014C7.02261 0.198712 6.63443 0.0378152 6.22963 0.0377198C5.82483 0.0376244 5.43657 0.198338 5.15027 0.484506L1.50173 4.13305C0.835065 4.80155 0.460693 5.70712 0.460693 6.65122C0.460693 7.59532 0.835065 8.50089 1.50173 9.16939L5.15027 12.8179C5.43657 13.1041 5.82483 13.2648 6.22963 13.2647C6.63443 13.2646 7.02261 13.1037 7.30877 12.8174C7.59494 12.5311 7.75566 12.1429 7.75556 11.7381C7.75547 11.3333 7.59457 10.9451 7.30827 10.6589L4.82673 8.17738H13.7731C14.1779 8.17738 14.566 8.01659 14.8523 7.73038C15.1385 7.44417 15.2993 7.05598 15.2993 6.65122C15.2993 6.24646 15.1385 5.85827 14.8523 5.57206C14.566 5.28585 14.1779 5.12506 13.7731 5.12506Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevVector);
export default __webpack_public_path__ + "static/media/prevVector.46b9646a8c1a8c361f8397c753059f9c.svg";
export { ForwardRef as ReactComponent };